// extracted by mini-css-extract-plugin
export default {"alert":"alert_alert__F6+K9","yes":"alert_yes__n4XEv","no":"alert_no__Um00b"};